import type { KeyboardEvent } from 'react';

import { focusPendingItem, type MenuContextValue } from './MenuContext';

const OPEN_KEYS = new Set(['Enter', ' ', 'ArrowDown', 'ArrowUp']);

/** Opens the menu, or moves into an open one, onto its first or last item. */
function openOnto(menu: MenuContextValue, which: 'first' | 'last'): void {
    menu.pendingFocus.current = which;
    if (menu.isOpen) {
        focusPendingItem(menu);
    } else {
        menu.setOpen(true);
    }
}

/** A panel trigger's keys: Enter and Space are the browser's click; a list also opens on the arrows. */
export function handlePanelKey(menu: MenuContextValue, event: KeyboardEvent<HTMLElement>): void {
    if (menu.kind !== 'list') return;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        openOnto(menu, event.key === 'ArrowUp' ? 'last' : 'first');
    } else if ((event.key === 'Enter' || event.key === ' ') && !menu.isOpen) {
        // The browser's click opens the list; focus follows once it has rendered.
        menu.pendingFocus.current = 'first';
    }
}

/** A menu trigger's keys: Enter, Space and the arrows open onto an item, Tab moves into an open menu. */
export function handleMenuKey(menu: MenuContextValue, event: KeyboardEvent<HTMLElement>): void {
    if (OPEN_KEYS.has(event.key)) {
        event.preventDefault();
        openOnto(menu, event.key === 'ArrowUp' ? 'last' : 'first');
    } else if (event.key === 'Tab' && !event.shiftKey && menu.isOpen) {
        event.preventDefault();
        openOnto(menu, 'first');
    }
}
